import { isNumber } from "src/utils/isNumber";
import {
  ONLY_INITIAL_EVALUATION_FILTER_TEXT,
  BOTH_EVALUATION_FILTER_TEXT,
} from "src/technicalRiskAssessment/components/pages/assessmentLibrary/constants";
import { DisplayData } from "./types/displayData";
import { FilterOptions } from "./types/filterOptions";
import AssessmentUtilService from "./assessmentUtilService";
class AssessmentFilterService {
  filterAssessments(assessments: DisplayData[], appliedFilters: FilterOptions) {
    assessments = this.filterAssessmentsByVideoStatuses(
      assessments,
      appliedFilters.videoStatuses
    );
    assessments = this.filterAssessmentsByAvailability(
      assessments,
      appliedFilters.assessmentsAvailable
    );
    assessments = this.filterAssessmentsByRebaScores(
      assessments,
      appliedFilters.rebaScoreRanges
    );
    return assessments;
  }

  filterAssessmentsByVideoStatuses(
    assessments: DisplayData[],
    videoStatuses: string[]
  ) {
    if (videoStatuses.length === 0) {
      return assessments;
    }
    let videoStatusesSet = new Set(videoStatuses);
    return assessments.filter((assessment) => {
      if (
        this.isAssessmentProcessed(assessment) &&
        videoStatusesSet.has("Processed")
      ) {
        return true;
      }

      return (
        videoStatusesSet.has(assessment.initialEvaluation.value) ||
        videoStatusesSet.has(assessment.followUpEvaluation.value)
      );
    });
  }

  isAssessmentProcessed(assessment: DisplayData) {
    return (
      isNumber(assessment.initialEvaluation.value) ||
      isNumber(assessment.followUpEvaluation.value)
    );
  }

  filterAssessmentsByAvailability(
    assessments: DisplayData[],
    availability: string[]
  ) {
    if (availability.length === 0) {
      return assessments;
    }
    let availabilitySet = new Set(availability);
    return assessments.filter((assessment) => {
      if (
        this.doesAssessmentHaveOnlyInitialEvaluation(assessment) &&
        availabilitySet.has(ONLY_INITIAL_EVALUATION_FILTER_TEXT)
      ) {
        return true;
      }
      return (
        this.doesAssessmentHaveBothEvaluations(assessment) &&
        availabilitySet.has(BOTH_EVALUATION_FILTER_TEXT)
      );
    });
  }

  doesAssessmentHaveOnlyInitialEvaluation(assessment: DisplayData) {
    return (
      assessment.followUpEvaluation.value === "" &&
      assessment.initialEvaluation.value !== ""
    );
  }

  doesAssessmentHaveBothEvaluations(assessment: DisplayData) {
    return (
      assessment.followUpEvaluation.value !== "" &&
      assessment.initialEvaluation.value !== ""
    );
  }

  filterAssessmentsByRebaScores(
    assessments: DisplayData[],
    rebaScoreRanges: string[]
  ) {
    if (rebaScoreRanges.length === 0) {
      return assessments;
    }

    let rebaScoreBorderClassesSet = new Set(
      rebaScoreRanges.map((scoreRange) =>
        AssessmentUtilService.getRebaBorderClassFromRangeString(scoreRange)
      )
    );

    return assessments.filter((assessment) => {
      return (
        rebaScoreBorderClassesSet.has(
          assessment.initialEvaluation.borderClass
        ) ||
        rebaScoreBorderClassesSet.has(assessment.followUpEvaluation.borderClass)
      );
    });
  }
}

export default new AssessmentFilterService();
